<template>
  <v-modal id="modal-template-requirements" :key="update_requirements">
    <span slot="header">
      {{ i18nJS.print_requirements }}
    </span>
    <div>
      <div v-for="(requirement, index) in requirements" v-bind:key="index">
        <template v-if="M_allowedRequirement(requirement.model)">
          <component
            :is="requirement.model + '-requirement'"
            :key="requirement.name + index"
            :buId="buId"
            :params="requirementsParams"
            :requirement="requirement"
            :index="index"
            @selected="selectRequirement($event, requirement.model)"
            style="margin-bottom: 10px"
          ></component>
        </template>
      </div>
      <!-- se e' richiesto il gpds_id devo instanziare un componente per selezionare l'utente se non è già presente -->
      <guest-requirement v-if="guestReqPresence" :buId="buId" :params="requirementsParams" style="margin-bottom: 10px"></guest-requirement>
    </div>
    <div style="display: flex" v-if="loading"><spinner :visible="true"></spinner></div>
    <a slot="footer" class="btn btn-success href=javascript:void(0)" @click="print" :disabled="!requirements">
      {{ i18nJS.command.print }}
    </a>
  </v-modal>
</template>
<script>
import vModal from '../vModal';
import apiConnector from '@/epersonam/apiConnector';
import userRequirement from './models/userRequirement';
import guestRequirement from './models/guestRequirement';
import dateRequirement from './models/dateRequirement';
import relativeRequirement from './models/relativeRequirement';
import spinner from '../spinner';
import { HowPrint } from '../models/howPrint';
import { assignParsedValue, checkRequirementCompleted, allowedRequirement } from './functions';
import { DischargeLetter } from '../models/dischargeLetter';
import { Route } from '../../route';
import { print } from '../../mixins/print';

export default {
  name: 'reportTemplatesRequirements',
  components: {
    vModal,
    userRequirement,
    guestRequirement,
    spinner,
    dateRequirement,
    relativeRequirement,
  },
  props: [],
  mixins: [print],
  data() {
    return {
      buId: null,
      requirements: [],
      url: null,
      header: null,
      body: null,
      footer: null,
      how_print: new HowPrint(),
      loading: false,
      requirementsParams: {},
      gpds_id: null,
      update_requirements: false,
      WAITING_POPUP_FADE: 500,
      close_popup_selectors: ['modal-backdrop', 'fa-xmark', 'btn-close'],
    };
  },
  mounted() {
    eventBus.$on('openModalTemplateRequirements', (result) => {
      this.loading = true;
      apiConnector()
        .get(`/it/report_templates/${result.data}`)
        .then((res) => {
          this.loading = false;
          this.requirements = res.data.requirements;
          this.body = res.data.body;
          this.header = res.data.header;
          this.footer = res.data.footer;
          if (
            ((!this.requirements || this.requirements.length == 0) && !this.requirementsParams.print_with_gpds_id) ||
            ((!this.requirements || this.requirements.length == 0) && this.requirementsParams.print_with_gpds_id && this.gpds_id)
          ) {
            this.print();
          }
        });
      this.buId = result.bu_id;
      this.url = result.url;
      this.how_print = result.how_print || new HowPrint(result.how_print);
      // se sono presenti parametri utili emetto eventi per avvisare i componenti dei requisiti che c'e' un parametro a loro utile
      this.requirementsParams = result.params || {};
      this.gpds_id = this.requirementsParams.guest_period_data_set_id;
      this.parsedValue = {};
      // this.initRequirementComponents()
      $('#modal-template-requirements').modal('show');
      eventBus.$on('guest_period_data_set_id_selected', (result) => {
        this.gpds_id = result;
      });
    });
    document.addEventListener('click', this.clearSelection);
  },
  computed: {
    guestReqPresence() {
      return (
        this.requirements &&
        this.requirements.length >= 0 &&
        this.requirementsParams.print_with_gpds_id &&
        !this.requirementsParams.guest_period_data_set_id &&
        !this.requirements.find((req) => req.model == 'guest')
      );
    },
    i18nJS() {
      return window.i18nJS;
    },
  },
  destroyed() {
    document.removeEventListener('click', this.clearSelection);
  },
  methods: {
    clearSelection(e) {
      const { close_popup_selectors, WAITING_POPUP_FADE } = this;
      const current_selection = e.target.classList;
      const is_close_poup = close_popup_selectors.some((sel) => current_selection.contains(sel));
      if (is_close_poup) {
        setTimeout(() => (this.update_requirements = !this.update_requirements), WAITING_POPUP_FADE);
      }
    },
    async print() {
      if (checkRequirementCompleted(this.parsedValue, this.requirements, this.print_with_gpds_id, this.gpds_id)) {
        this.loading = true;
        const translates = await this.PU_translateVariablesAndResolve(
          this.parsedValue,
          [this.header, this.body, this.footer],
          this.requirements,
          this.gpds_id,
        );
        this.how_print['templateRequirements'] = true;
        this.how_print.template['header'] = translates[0];
        this.how_print.template['body'] = translates[1];
        this.how_print.template['footer'] = translates[2];
        apiConnector()
          .post(`${this.url}`, { how_print: this.how_print, guest_period_data_set_id: this.gpds_id })
          .then((res) => {
            var w = window.open('about:blank');
            w.document.open();
            w.document.write(res.data);
            w.document.close();
            this.loading = false;
            $('#modal-template-requirements').modal('hide');
            setTimeout(() => (this.update_requirements = !this.update_requirements), this.WAITING_POPUP_FADE);
          });
      } else {
        console.log('requisiti mancanti');
      }
    },
    selectRequirement(selected, name) {
      this.parsedValue = assignParsedValue(this.parsedValue, selected, name);
    },
    M_allowedRequirement(model) {
      return allowedRequirement(model);
    },
  },
};
</script>

<style lang="scss" scoped></style>
